module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 79300.3e86551b.png";